import { RecipientDto } from './adminChannelTypes';

export const formatRecipient = (recipient?: RecipientDto) => {
  if (recipient) {
    return `[#${recipient.id}] ${recipient.firstName} ${recipient.lastName}`;
  } else {
    return '';
  }
};
